import {Compendium} from 'app/components/promo_action/compendium';
import {inject} from 'mobx-react';

class PromoActionCompenigma extends Compendium {
    static cookieName = 'compenigma-menu';
}

export default inject('currentTimeStore')(PromoActionCompenigma);
